module.exports = __webpack_public_path__ + "media/images/wedding/top/reason1-0050a090a0bee3af0edc05ef89500878.jpg";